import {NotEmptyChecker} from "../../../../recordpage/common/checkers/NotEmptyChecker";
import MissingDataFirstVisit from "./MissingDataFirstVisit";

const MissingDataNewComplaint = [
    ...MissingDataFirstVisit,
    {path: "subjective.complaint.currentPrevious", checker: NotEmptyChecker},
];

export default MissingDataNewComplaint;